import service from '@/request/api'; // 导入api接口

function jumpByStatusCommon(productId, status, orderId) {
  // 跳转第三方逻辑变化
  service.CommonForms.jumpThirdServer({ orderId }).then((res) => {
    console.log(res);
    if (res.data) {
      window.location.href = res.data;
    }
  });
}

export default jumpByStatusCommon;

